var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.625C6.7125 0.625 0 7.225 0 15.365C0 21.8787 4.2975 27.4025 10.2563 29.35C11.0063 29.4887 11.2812 29.0325 11.2812 28.6413C11.2812 28.2913 11.2688 27.3638 11.2625 26.135C7.09 27.0238 6.21 24.1575 6.21 24.1575C5.5275 22.4563 4.54125 22.0012 4.54125 22.0012C3.1825 21.0875 4.64625 21.1063 4.64625 21.1063C6.1525 21.2087 6.94375 22.625 6.94375 22.625C8.28125 24.8787 10.455 24.2275 11.3125 23.8512C11.4475 22.8975 11.8338 22.2487 12.2625 21.88C8.93125 21.5112 5.43 20.2437 5.43 14.5963C5.43 12.9875 6.01125 11.6725 6.97375 10.6412C6.805 10.2687 6.29875 8.77 7.105 6.74C7.105 6.74 8.36125 6.345 11.23 8.25125C12.43 7.92375 13.705 7.76125 14.98 7.75375C16.255 7.76125 17.53 7.92375 18.73 8.25125C21.58 6.345 22.8362 6.74 22.8362 6.74C23.6425 8.77 23.1362 10.2687 22.9862 10.6412C23.9425 11.6725 24.5238 12.9875 24.5238 14.5963C24.5238 20.2588 21.0175 21.505 17.68 21.8675C18.205 22.31 18.6925 23.2138 18.6925 24.595C18.6925 26.5675 18.6737 28.1525 18.6737 28.6313C18.6737 29.0175 18.9363 29.4788 19.705 29.3312C25.7062 27.3962 30 21.8687 30 15.365C30 7.225 23.2838 0.625 15 0.625Z",
    fill: "#3C1A50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e995e2940c577d884e037aa762a0c606.svg";
export { ForwardRef as ReactComponent };